import { Paper } from "@mui/material";
import MuiTabs from "../muiTabs/tabs.component";

const FieldInfoCard = ({ field, sensors }) => {
  const handleTabChange = () => {};
  return (
    <Paper elevation={0} sx={{ p: 2, height: "100%" }}>
      <MuiTabs onChange={handleTabChange} field={field} sensors={sensors} />
    </Paper>
  );
};

export default FieldInfoCard;
